const mdContext = require.context("assets/release_notes", false, /\.md$/)

const getLatestVersion = () => {
  const keys = mdContext.keys()
  if (!keys.length) return null

  // Sort by filename date descending, pick the first
  const sorted = [...keys].sort((a, b) => b.localeCompare(a))
  const latest = sorted[0]

  // Extract version from filename: YYYY-MM-DD_vX.Y.Z.{lang}.md
  const match = latest.match(/_v([\d.]+)\.[a-z]{2}\.md$/)
  return match ? match[1] : null
}

export default getLatestVersion
